module.exports = __webpack_public_path__ + "static/media/010.a4004b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/010.jpg
// module id = 517
// module chunks = 0